<template>
    <b-row :class="getClasses(entry)" v-if="entry">
    	<b-col cols="12" md="6">
    		<b-row>
                <b-col cols="12" class="notification-setting-entry__title">
                    <div class="notification-setting-entry__title-wrapper" >
                    	<div class="notification-setting-entry__text" v-html="settingText"></div>
                    	 <div class="notification-setting-entry__help" v-show="$t('userSettingsHelp.'+entry.notificationTypeId) != ''">
                    	    <button class="App__tooltipButton" type="button" v-tooltip="{
                    	    content: $t('userSettingsHelp.'+entry.notificationTypeId),
                    	    placement: 'top-center',
                    	    trigger:'hover click',
                    	    classes: ['info'],
                    	    offset: 10,
                    	    autoHide:false
                    	  }"><span>?</span></button>
                    	</div>
                    </div>
                </b-col>
            </b-row>
        </b-col>
        <b-col>
               <b-row>
                <!--<b-col md="auto" v-if="false">
                    <label :for="'toggleMyAll-'+entry.notificationTypeId">All</label>
                    <div class="on-off-switch-field">
                            <input :id="'toggleMyAll-'+entry.notificationTypeId" class="on-off-switch" :checked="notifyAll"  value="1" type="checkbox" @change="toggleNotifyAll()">
                            <label :for="'toggleMyAll-'+entry.notificationTypeId"></label>
                    </div>
                </b-col>-->
                <b-col cols="12" class="notification-setting-entry__email">
                	<b-row>
	                	<b-col cols="6" md="4">
	                    <label :for="'toggleEmail-'+entry.notificationTypeId">Email</label>
	                	</b-col>
                    	<b-col cols="6" md="4">
		                    <label v-show="false" :for="'toggleEmail-'+entry.notificationTypeId">Email</label>
		                    	<div v-if="forceEmail" class="on-off-switch-field disabled">
		                        <input :id="'toggleEmail-'+entry.notificationTypeId" class="on-off-switch" :checked="entry.notifyEmailMyLcr" v-model="entry.notifyEmailMyLcr" value="1" type="checkbox" @change="toggleNotifyMy()" disabled="disabled">
		                        <label :for="'toggleEmail-'+entry.notificationTypeId"></label>
		                    </div>
		                    <div v-else class="on-off-switch-field">
		                            <input :id="'toggleEmail-'+entry.notificationTypeId" class="on-off-switch" :checked="entry.notifyEmailMyLcr" v-model="entry.notifyEmailMyLcr" value="1" type="checkbox" @change="toggleNotifyMy()">
		                            <label :for="'toggleEmail-'+entry.notificationTypeId"></label>
		                    </div>
		                </b-col>
	            	</b-row>
                </b-col>
                <b-col cols="12" class="notification-setting-entry__push">
	            	<b-row>
	                	<b-col cols="6" md="4">
                    	<label :for="'togglePush-'+entry.notificationTypeId">Push Notification</label>
                   		 </b-col>
                    	<b-col cols="6" md="4">
	                  	  <label v-show="false" :for="'togglePush-'+entry.notificationTypeId">Push Notification</label>
	                  	  <div class="on-off-switch-field">
	                            <input :id="'togglePush-'+entry.notificationTypeId" class="on-off-switch" :checked="entry.notifyAppMyLcr"  v-model="entry.notifyAppMyLcr" value="1" type="checkbox" @change="toggleNotifyMy()">
	                            <label :for="'togglePush-'+entry.notificationTypeId"></label>
	                	    </div>
		                </b-col>
	            	</b-row>
                </b-col>
                <b-col cols="12" v-if="!hideWeb" class="notification-setting-entry__web">
                		<b-row>
						<b-col cols="6" md="4"><label :for="'toggleWeb-'+entry.notificationTypeId">Web</label></b-col>
                    	<b-col cols="6" md="4">
                    <label v-show="false" :for="'toggleWeb-'+entry.notificationTypeId">Web</label>
	                    <div class="on-off-switch-field">
	                            <input :id="'toggleWeb-'+entry.notificationTypeId" class="on-off-switch" :checked="entry.notifyBrowserMyLcr" v-model="entry.notifyBrowserMyLcr" value="1" type="checkbox" @change="toggleNotifyMy()">
	                            <label :for="'toggleWeb-'+entry.notificationTypeId"></label>
	                    </div>
		                </b-col>
	            	</b-row>
                </b-col>
                <b-col cols="12" class="notification-setting-entry__all"  md="auto">
                    	<b-form-checkbox v-model="notifyOther" value="true" class="mb-3" @change="toggleNotifyOther()"><span><strong>Include requests NOT assigned to me.</strong></span></b-form-checkbox>
              	</b-col>
            </b-row>
              	</b-col>
            </b-row>
</template>

<script>
export default {
    name:'UserNotificationSetting',
    props: ['value','setting', 'forceEmail', 'hideWeb'],
    data() {
        return {
        	notifyOther:false
        }
    },
    mounted: function() {
    	if (this.entry) {
	    	if (
	    	    ( this.entry.notifyEmailMyLcr == this.entry.notifyEmailAllLcr && ( this.entry.notifyEmailMyLcr == true || this.entry.notifyEmailMyLcr == 1)) ||
	    	    ( this.entry.notifyAppMyLcr == this.entry.notifyAppAllLcr && ( this.entry.notifyAppMyLcr == true || this.entry.notifyAppMyLcr == 1))
	    	) {
	    	    this.notifyOther = true;
	    	} else {
	    		this.notifyOther = false;
	    	}
	    }

    },
    computed: {
    	settingText() {
    		let txt = this.$t('userSettings.'+ this.setting);
    		if (this.$t('userSettingsDetails.'+ this.setting) != 'userSettingsDetails.'+ this.setting
    		&& this.$t('userSettingsDetails.'+ this.setting) != null
    		) {
    			txt += "<span>" + this.$t('userSettingsDetails.'+ this.setting) + "</span>";
    		}
    		return txt;
    	},
        notifyAll() {
            if (
                this.entry.notifyEmailMyLcr == true &&
                this.entry.notifySoundMyLcr == true &&
                this.entry.notifyAppMyLcr == true &&
                this.entry.notifyBrowserMyLcr == true
            ) {
                return true;
            }
            return false;
        },

        calcNotifyOther() {
            if (
                this.entry.notifyEmailAllLcr == true ||
                this.entry.notifySoundAllLcr == true ||
                this.entry.notifyAppAllLcr == true ||
                this.entry.notifyBrowserAllLcr == true
            ) {
                return true;
            }
            return false;
        },


        entry() {
            if (this.value && this.setting) {
                let x = 0;
                for (x =0; x < this.value.length; x++) {
                    if (this.value[x].notificationTypeId == this.setting) {
                        return this.value[x];
                    }
                }
            }
            return null;
        },
    },
    methods: {
    	getClasses(e) {
    		return "notification-setting-entry notification-setting-entry__" + e.notificationTypeId;
    	},

    	toggleNotifyOther() {
    	    if(this.notifyOther) {
				this.entry.notifyEmailAllLcr = this.entry.notifyEmailMyLcr;
				this.entry.notifySoundAllLcr = this.entry.notifySoundMyLcr;
				this.entry.notifyAppAllLcr = this.entry.notifyAppMyLcr;
				this.entry.notifyBrowserAllLcr = this.entry.notifyBrowserMyLcr;
			} else {
    	        this.entry.notifyEmailAllLcr = false;
    	        this.entry.notifySoundAllLcr = false;
    	        this.entry.notifyAppAllLcr = false;
    	        this.entry.notifyBrowserAllLcr = false;
    	    }
    	    this.$emit('notificationsetting:update', this.entry);
    	},

    	toggleNotifyMy() {
    		this.entry.notifyEmailAllLcr = this.entry.notifyEmailMyLcr;
    		this.entry.notifySoundAllLcr = this.entry.notifySoundMyLcr;
    		this.entry.notifyAppAllLcr = this.entry.notifyAppMyLcr;
    		this.entry.notifyBrowserAllLcr = this.entry.notifyBrowserMyLcr;

    	    if(!this.notifyOther) {
    	        this.entry.notifyEmailAllLcr = false;
    	        this.entry.notifySoundAllLcr = false;
    	        this.entry.notifyAppAllLcr = false;
    	        this.entry.notifyBrowserAllLcr = false;
    	    }
    	    this.$emit('notificationsetting:update', this.entry);
    	},



        toggleNotifyAll() {
            if(this.notifyAll) {
                if (this.forceEmail) {
                	this.entry.notifyEmailMyLcr = true;
                } else {
                	this.entry.notifyEmailMyLcr = false;
                }
                this.entry.notifySoundMyLcr = false;
                this.entry.notifyAppMyLcr = false;
                this.entry.notifyBrowserMyLcr = false;
            } else {
                this.entry.notifyEmailMyLcr = true;
                this.entry.notifySoundMyLcr = true;
                this.entry.notifyAppMyLcr = true;
                this.entry.notifyBrowserMyLcr = true;
            }
            this.$emit('notificationsetting:update', this.entry);
        }
    }
}

</script>
